import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form'
import { Label, Error, Hint } from '@progress/kendo-react-labels'
import { DateTimePicker } from '@progress/kendo-react-dateinputs'

const FormDateTimePicker = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage, touched, label, id, valid,
    disabled, hint, wrapperStyle, hintDirection, value, required, ...others
  } = fieldRenderProps

  const showValidationMessage = touched && validationMessage
  const showHint = !showValidationMessage && hint
  const hintId = showHint ? `${id}_hint` : ''
  const errorId = showValidationMessage ? `${id}_error` : ''
  const labelId = label ? `${id}_label` : ''

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
        {required &&
          <span className='text-danger'>*</span>
        }
        {label} &nbsp;
        {
          showValidationMessage &&
          <Error id={errorId}  >{validationMessage}</Error>
        }

      </Label>
      <div className='k-form-field-wrap'>
        <DateTimePicker
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId} ${errorId}`}
          valid={valid}
          id={id}
          disabled={disabled}
          value={value}
          {...others}
        />
        {
          showHint &&
          <Hint id={hintId} direction={hintDirection}>{hint}</Hint>
        }
      </div>
    </FieldWrapper>
  )
}

export default FormDateTimePicker